import {useState} from "react";
import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";
import {
    pressDontKnow,
    renderQuestionOptionStyle
} from "../../../controllers/flashScreens/questionsStepScreen/QuestionsOptionItemController";
import {kSystemIcons} from "../../../constants/icons";


export default function NeoFlashQuestionOptionItem({isLast, option, optionSelected, setOptionSelected, onDontKnowPress}) {
    // Used in FlashQuestionOptionsList to display
    // one single question option item

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    if (isNullOrUndefined(option) || isNullOrUndefined(option?.proposal))
        return null
    return(
        <div className={`select-none cursor-pointer bg-backgroundLight5 grow min-h-[48px] flex justify-between items-center px-[12px] py-[12px] lg:px-[16px] border-1 rounded-[8px] ${renderQuestionOptionStyle(option, optionSelected, isHovered)}`}
             onClick={isNullOrUndefined(setOptionSelected) ? null : () => setOptionSelected(option)}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                        <span className={"text-[18px]"}>
                            {option?.proposal ?? "Erreur"}
                        </span>
                    </MathJax>
                </MathJaxContext>
                {isLast
                    ? <i onClick={(event) => pressDontKnow(event, onDontKnowPress)} className="material-icons text-[18px] lg:text-[20px] text-greyLight7 transition ease-in-out hover:text-greyLight11 duration-100">
                        help
                      </i>
                    : <div className={`${isOptionSelected(option, optionSelected) ? "flex" : "hidden"} bg-primary w-[24px] h-[24px] rounded-full justify-center items-center mt-[2px] ml-[8px]`}>
                        <i className="material-icons text-[18px] text-white transition ease-in-out hover:text-greyLight11 duration-100">
                            {kSystemIcons.check}
                        </i>
                      </div>
                }
        </div>
    );

    // METHODS
    // ---- UI : Is option selected
    function isOptionSelected(option, optionSelected) {
        if (option !== null && optionSelected !== null) {
            return option.proposal === optionSelected.proposal
        } else {
            return false
        }
    }
}